import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DiscountsService {

  getDiscountOptions () {
  return [
    {
      id: 1,
      name: 'Select one',
      disabled: true,
    },
    {
      id: 2,
      name: 'Good Student discount',
      disabled: false,
    },
    {
      id: 3,
      name: 'Pan-Mass Challenge discount',
      disabled: false,
    },
    {
      id: 4,
      name: 'Student Away discount',
      disabled: false,
    }
  ]
}
}
